var  PRODUCT_MUST_ID = 40914461425700; // Replace with your actual variant ID

document.addEventListener('submit', async (e) => {
  var form = e.target;
  if (!form.matches('form[action^="/cart/add"]')) return;

  e.preventDefault();

  var formData = new FormData(form);

  // Add the product user selected
  await fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  });

  // Ensure mandatory product is present
  await ensureProductMustInCart();

  // Re-render the cart drawer
  await updateCartDrawerViaShopify();
});


async function ensureProductMustInCart() {
  var cart = await fetch('/cart.js').then(res => res.json());
  var alreadyAdded = cart.items.find(item => item.variant_id === PRODUCT_MUST_ID);

  if (!alreadyAdded) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: PRODUCT_MUST_ID,
        quantity: 1
      })
    });
  }
}

async function updateCartDrawerViaShopify() {
  var sectionIds = ['cart-drawer', 'cart-icon-bubble'];

  var response = await fetch(`/cart?sections=${sectionIds.join(',')}`);
  var parsedState = await response.json();

  // Shopify often returns sections inside `sections` key; fallback if not
  parsedState.sections = parsedState.sections || parsedState;

  var cartDrawerElement = document.querySelector('cart-drawer');
  if (cartDrawerElement && typeof cartDrawerElement.renderContents === 'function') {
    cartDrawerElement.renderContents(parsedState);
  } else {
    console.warn('Cart drawer element or renderContents() not found.');
  }

  // Wait a little before modifying DOM (ensures render is complete)
  setTimeout(disableProductMustRemove, 250);
}

function disableProductMustRemove() {
  var drawerItems = document.querySelectorAll('[data-cart-item]');

  drawerItems.forEach(item => {
    var variantId = parseInt(item.dataset.cartItemVariant, 10);

    if (variantId === PRODUCT_MUST_ID) {
      var removeBtn = item.querySelector('[data-remove-item]');
      if (removeBtn) {
        removeBtn.setAttribute('disabled', 'true');
        removeBtn.style.pointerEvents = 'none';
        removeBtn.style.opacity = '0.5';
        removeBtn.title = 'This item is required and cannot be removed';
      }
    }
  });
}


// Wait until the custom element is defined
customElements.whenDefined('cart-items').then(() => {
  var originalUpdateQuantity = CartItems.prototype.updateQuantity;

  CartItems.prototype.updateQuantity = async function (line, quantity, name) {
    // Only intercept if removing (i.e., setting quantity to 0)
    if (parseInt(quantity, 10) === 0) {
      var cart = await fetch('/cart.js').then(res => res.json());
      var item = cart.items[line - 1]; // line is 1-based index

      if (item?.variant_id === PRODUCT_MUST_ID) {
        //alert("This item is required and cannot be removed from the cart.");
        return; // block the removal
      }
    }

    // Call the original method if it's not product-must or not a removal
    return originalUpdateQuantity.call(this, line, quantity, name);
  };
});


var customStyle = document.createElement('style');
customStyle.innerHTML = `
  cart-remove-button button[aria-label="Remove Meal Guard Freeze Pack"] {
    opacity: 0.5;
    cursor: not-allowed;
  }
  quantity-input:has(+ cart-remove-button button[aria-label="Remove Meal Guard Freeze Pack"]) {
  display: none !important;
}
`;
document.head.appendChild(customStyle);